module.exports = __webpack_public_path__ + "static/media/cancel-complete.7ac807e3.png";